// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shippo-attribute-tag{border-radius:3px;color:#fff;display:inline-block;font-size:.8rem;font-weight:400;padding:2px 5px;white-space:nowrap}.shippo-attribute-tag[type=BESTVALUE]{background:#22b9ca}.shippo-attribute-tag[type=FASTEST]{background:#9b0b54}.shippo-attribute-tag[type=CHEAPEST]{background:#fa3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
